import { Alert } from '@uhg-abyss/web/ui/Alert';
import { find } from 'lodash';
import { useState } from 'react';

import { Constants } from '../../../../common/Constants';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useLagoon } from '../../../../hooks/useLagoon';

export const VisionAlertBanner = ({
  chipValue,
  isVisionCare,
}: {
  chipValue: string;
  isVisionCare: boolean;
}) => {
  const [showVisionAlertBanner, setShowVisionAlertBanner] = useState<boolean>(
    chipValue === Constants.CHIPS_CATEGORIES.VISION && isVisionCare
  );
  const lagoonUIMessage = useLagoon('ui-messaging')();
  const visionBannerTitle = find(lagoonUIMessage, {
    key: ConstantsLagoon.UI_MESSAGING.VISION_ALERT_BANNER,
  })?.title;

  const visionBannerDesc = find(lagoonUIMessage, {
    key: ConstantsLagoon.UI_MESSAGING.VISION_ALERT_BANNER,
  })?.message;

  const visionBannerCTAButton = find(lagoonUIMessage, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE.VIEW_VISION_COVERAGE_CTA_URL,
  })?.message;

  const visionBannerCTALink = find(lagoonUIMessage, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE.VIEW_VISION_COVERAGE_CTA_URL,
  })?.url;

  if (!showVisionAlertBanner) {
    return null;
  }

  return (
    <Alert
      cta={{
        type: 'link',
        props: {
          children: visionBannerCTAButton,
          onClick: () => {
            window.location.href = visionBannerCTALink;
          },
        },
      }}
      data-testid="vision-alert-banner"
      onClose={() => {
        setShowVisionAlertBanner(false);
      }}
      status="info"
      title={visionBannerTitle}
    >
      {visionBannerDesc}
    </Alert>
  );
};
